import { Feature, Map } from "ol";
import { getAllFeatureFlags, setCookie } from "../../util/general_util";
import { setLayerVisible } from "./helper_functions";
import { addPOI_asStop, get_campgroundPinPopup, get_campgroundPinPopup_mobile, get_poiOnRoutePinPopup, get_poiPinPopup, getPOIs_onRoute } from "../api_utils";
import { Geometry, LineString } from "ol/geom";
import { Coordinate } from "ol/coordinate";
import { Extent, getCenter as getExtentCenter } from 'ol/extent';
import { log_openRoadsClick, rvShare_click_log } from "../../log";
import { init_splides } from "../../rv_share_integration";
import { add_pois_on_route } from "./map_displays";
import { display_stop_popout, hide_map_loadingIcon, show_map_loadingIcon } from "../ui_utils";
import { get_stop_from_stopID, getClosestStopIndices, inc_interaction_counter } from "../util/helper_functions";
import { handle_add_poi_click } from "../update_trip_utils";
import { FeatureLike } from "ol/Feature";

function handle_stopPin_click(properties:{[key:string]:any}) {
    const stopID:string = properties.stopID;
    // $(`[viewstoppopout][tab="#stays"][leg="${legIndex}"][stop="${stopIndex}"]`).trigger("click");
    const stopData = get_stop_from_stopID(stopID, window.tripPlannerCurrentTrip);
    if (stopData == null) return;

    display_stop_popout(stopID, !stopData.stop.fromUserQuery, true)
};

async function handle_stayPin_click(feature:Feature, properties:{[key:string]:any}, map:Map) {
    const s2n_id:boolean = properties.s2n_id != null && properties.s2n_id != undefined;

    let s2n_v1 = false;
	if("s2n_v1" in window.featureFlags){
		s2n_v1 = window.featureFlags["s2n_v1"]
	}else{
		await getAllFeatureFlags();
		s2n_v1 = window.featureFlags["s2n_v1"]
	};

    const campData:any = {
		// "legIndex":properties.leg,
		// "stopIndex":properties.stop,
        "stopID": properties.stopID,
		"campID":properties.campID,
		"genie_score":properties.genie_score,
		"genie_match":properties.genie_match === undefined? null: properties.genie_match,
		"camp_name":properties.camp_name,
		"campPageURL":properties.campPageURL,
		"is_s2n":s2n_v1 && s2n_id,
		"addr": properties.addr,
		"dist": properties.dist
	};

    const stopData = get_stop_from_stopID(properties.stopID, window.tripPlannerCurrentTrip);
    if (!stopData) return;

    const geom:Geometry = feature.getGeometry() as Geometry;
    const ext:Extent = geom.getExtent();
    const loc:Coordinate = getExtentCenter(ext);

    if (map.getTarget() == "stopPopoutMap") {
        get_campgroundPinPopup_mobile(campData, stopData.stop.fromUserQuery,window.tripPlannerCurrentTrip.filters.dist_unit).then(popupHtml => {
            $("#map-stay-mobile").html(popupHtml);
            $("#map-stay-mobile").removeClass("d-none");
            document.getElementById("stopPopout").dispatchEvent(new CustomEvent("stays.displayed"));
        }).catch(e => {
            console.error(e);
        })
    } else {
        get_campgroundPinPopup(campData, stopData.stop.fromUserQuery,window.tripPlannerCurrentTrip.filters.dist_unit).then(popupHtml => {
            const $campInfoPopup = $(popupHtml);
            window.map_campInfoPopup.setElement($campInfoPopup[0]);
            window.map_campInfoPopup.setPosition(loc);

            window.mainTripPlannerMap.getView().animate({
                center:[loc[0], loc[1]],
                duration: 500
            });

            document.getElementById("stopPopout").dispatchEvent(new CustomEvent("stays.displayed"));

        }).catch(e => {
            console.error(e);
        })
    }


};

function handle_poiPin_click(feature:Feature, properties:{[key:string]:any}, map:Map) {
    let geom:Geometry = feature.getGeometry() as Geometry;
    let ext:Extent = geom.getExtent();
    let loc:Coordinate = getExtentCenter(ext);

    get_poiPinPopup(properties).then(popupHtml => {
        let $poiInfoPopup = $(popupHtml)
        window.map_poiInfoPopup.setElement($poiInfoPopup[0]);
        window.map_poiInfoPopup.setPosition(loc);

        $poiInfoPopup.find("[add-poi-to-stop]").on("click", handle_add_poi_click);

        $("#mapPoiInfoWindow-close").off("click");
        $("#mapPoiInfoWindow-close").on("click", () => {
            $("#ol_map_poi_popup_card").hide();
        });

        if($("#tripMapTab").length){
            map.getView().animate({center:[loc[0] + .425, loc[1]], duration: 500});
        }else{
            map.getView().animate({center:loc, duration: 500});
        }
    });
};

function handle_poiPin_onRoute_click(feature:Feature, properties:{[key:string]:any}, map:Map) {
    let geom:Geometry = feature.getGeometry() as Geometry;
    let ext:Extent = geom.getExtent();
    let loc:Coordinate = getExtentCenter(ext);

    get_poiOnRoutePinPopup(properties).then(popupHtml => {
        let $poiInfoPopup = $(popupHtml)
        window.map_poiInfoPopup.setElement($poiInfoPopup[0]);
        window.map_poiInfoPopup.setPosition(loc);
        if($("#tripMapTab").length){
            map.getView().animate({center:[loc[0] + .425, loc[1]], duration: 500});
        }else{
            map.getView().animate({center:loc, duration: 500});
        }
        $poiInfoPopup.addClass("popUpAnimation");


        $("#mapPoiOnRouteInfoWindow-close").off("click");
        $("#mapPoiOnRouteInfoWindow-close").on("click", () => {
            $("#ol_map_poi_on_route_popup_card").hide();
        })

        $("[OpenRoadsReferLink]").off("click");
        $("[OpenRoadsReferLink]").on("click", function() {
            log_openRoadsClick();
        });

        $("[add-poi-on-route]").off("click");
        $("[add-poi-on-route]").on("click", function() {
            let PoiInfoCard:JQuery<HTMLElement> = $(this).closest("[poiInfoCardWrapper]");
            let poiID:number = parseInt(PoiInfoCard.attr("poiID"));
            let poiTypeID:number = parseInt(PoiInfoCard.find("[poiTypes]").text().replace(/[\[\]']+/g,''));
            let loc_str_arr:Array<string> = (PoiInfoCard.attr("loc") as string).split(",");
            let loc:{latitude:number,longitude:number} = {
                latitude: parseFloat(loc_str_arr[1]),
                longitude: parseFloat(loc_str_arr[0])
            };

            let closestStopsIndices:Array<{legIndex:number,stopIndex:number}> = getClosestStopIndices(window.tripPlannerCurrentTrip, loc);

            show_map_loadingIcon("Adding POI");
            addPOI_asStop(window.tripPlannerCurrentTrip, poiID, closestStopsIndices).then(trip => {
                window.tripPlannerCurrentTrip = trip;
                hide_map_loadingIcon();
                $("#ol_map_poi_on_route_popup_card").hide();
                document.dispatchEvent(new CustomEvent("trip.updated"));

                inc_interaction_counter();
            }).catch(e => {
                console.error(e);
                hide_map_loadingIcon();
            });
        });
    });
};

function handle_rv_pin_click(feature:Feature, properties:{[key:string]:any}) {
    let geom:Geometry = feature.getGeometry() as Geometry;
    let ext:Extent = geom.getExtent();
    let loc:Coordinate = getExtentCenter(ext);
    let id:number = properties.id;

    let popupCard = $(
        "<div id='rvRentalPopup' class='card position-relative' style='max-width:350px;'>"
        +
        // "<div class='card-header'><button id='rvRentalPopup-close' class='btn-close pt-3 float-end' type='button'></button></div>"
        // +
        $(`#${id}[rvRentalCard]`).html()
        +
        "</div>"
    );
    popupCard.find("[rentNowBtn]").addClass("d-none");
    popupCard.off("click");
    popupCard.find(".card-body").attr("role","button");
    popupCard.find(".card-body").on("click",function(event){
        if (event.target.matches("[rentNowBtn")) return;
        rvShare_click_log(id, popupCard.find("[rentNowBtn]").attr("href"));
        window.open(popupCard.find("[rentNowBtn]").attr("href"),"_blank");
    });
    window.map_rvRentalPopup.setElement(popupCard[0]);
    init_splides(popupCard.find("[rvRentalSplide]"))
    window.map_rvRentalPopup.setPosition(loc);
    window.mainTripPlannerMap.getView().animate({center:[loc[0] - 0.5, loc[1] + .325], duration: 500});
};

let cur_routewarn_feature:FeatureLike;
const routeWarn_info_el = document.getElementById("routeWarningInfo");

export function init_map_listeners(map:Map) {

    map.on("moveend", function(event) {
        if (window.poisOnRouteActive) {
            const activeTypes:number[] = $("[poi-on-route]:checked").map((idx,el)=>{return parseInt(el.getAttribute("poi-type"))}).toArray()
            const mapBounds = map.getView().calculateExtent(map.getSize());
                const dist:number = 5000 * map.getView().getZoom();
                const geom:LineString = new LineString(window.tripPlannerCurrentTrip.directions.routes[0].geometry.coordinates).simplify(0.5) as LineString;
                getPOIs_onRoute(geom.getCoordinates(), mapBounds, dist, activeTypes,$("#OpenRoads").prop("checked")).then(pois => {
                    if (!window.poisOnRouteActive) window.poisOnRouteActive = true;
                    add_pois_on_route(pois,$("#OpenRoads").prop("checked"));
                }).catch(e => {
                    console.error(e);
                });
        };
    });

    const mapContainer = document.getElementById('tripPlannerMap');
    var resizeObserver = new ResizeObserver(entries => {
        for (let entry of entries) {
            if (entry.target === mapContainer) {
                map.updateSize(); // Update the map size
            }
        }
    });
    resizeObserver.observe(mapContainer);

    $("[setMapLayer]").on("click", function() {
		const layerId:string = $(this).attr("layerId");
		setCookie("map", layerId, "", 36500);
		setLayerVisible(layerId);
    });

    map.on("click", function(event) {
        $("#rvRentalPopup").hide();

        map.forEachFeatureAtPixel(event.pixel, function(feature:Feature) {
            const properties = feature.getProperties();

            switch (properties.type) {
                case "rvForRent":
                    handle_rv_pin_click(feature, properties);
                    break;
                case "stopMarker":
                    handle_stopPin_click(properties);
                    break;
                case "routeWarning":
                    break;
                case "stayPin":
                    handle_stayPin_click(feature, properties, map);
                    break;
                case "poiPin":
                    handle_poiPin_click(feature, properties, map);
                    break;
                case "poiPin_onRoute":
                    handle_poiPin_onRoute_click(feature, properties, map);
                    break;
                case "poiPin_addedToStop":
                    break;
                default:
                    break;
            };
        });
    });

    map.on("pointermove", function(event) {
        const pixel = map.getEventPixel(event.originalEvent);

        if (routeWarn_info_el) {
            const routeWarnFeature = map.forEachFeatureAtPixel(pixel, function(feature) {
                if (feature.getProperties().type == "routeWarning") return feature;
            });
            if (routeWarnFeature) {
                routeWarn_info_el.style.left = pixel[0] + "px";
                routeWarn_info_el.style.top = pixel[1] + "px";
                if (routeWarnFeature != cur_routewarn_feature) {
                    routeWarn_info_el.style.visibility = 'visible';
                    routeWarn_info_el.innerText = routeWarnFeature.getProperties().warningText;
                };
            } else {
                routeWarn_info_el.style.visibility = 'hidden';
            };
            cur_routewarn_feature = routeWarnFeature;
        };
    });
};